import { FC } from 'react';
import { Link } from 'react-router-dom';

import { ReactComponent as OpportunitiesSvg } from 'assets/image/navbar/chesed-opportunites.svg';
import { ReactComponent as TotalHoursIcon } from 'assets/image/dashboard/total-hours.svg';
import { ReactComponent as TotalStudentsIcon } from 'assets/image/dashboard/pending-approval.svg';
import { ReactComponent as CircleArrowButton } from 'assets/image/dashboard/circle-arrow-button.svg';

import { OPPORTUNITIES_TABS } from 'core/constants';
import { urls } from 'core/appUrls';
import { getRedirectUrlWithTabHelper } from '../helpers';

import styles from './GeneralStatistics.module.scss';
import { IOrganisationDashboardByUserResponse } from '@joc/api-gateway/lib/api-client';
import { formatInteger, formatNumber } from 'core/functions/formatNumber';

export type GeneralStatisticsType = Pick<
	IOrganisationDashboardByUserResponse,
	'opportunitiesTotal' | 'totalSpendTime' | 'volunteersTotal'
>;

type GeneralStatisticsProps = {
	statistics: GeneralStatisticsType;
};

const GeneralStatistics: FC<GeneralStatisticsProps> = ({ statistics }) => {
	const totalOpportunitiesTitle = 'Total Opportunities';
	const totalHoursTitle = 'Total Hours';
	const totalVolunteersTitle = 'Total Volunteers';

	return (
		<section className={styles.generalStatistics}>
			<div className={styles.generalStatistics__item}>
				<OpportunitiesSvg className={styles.generalStatistics__item_icon} />
				<div className={styles.generalStatistics__item_content}>
					<span className={styles.generalStatistics__item_content_counter}>
						{formatInteger(statistics.opportunitiesTotal)}
					</span>
					<span className={styles.generalStatistics__item_content_title}>{totalOpportunitiesTitle}</span>
				</div>
				<Link
					to={getRedirectUrlWithTabHelper(OPPORTUNITIES_TABS.ALL)}
					className={styles.generalStatistics__item_link}
				>
					<CircleArrowButton title={totalOpportunitiesTitle} />
				</Link>
			</div>
			<div className={styles.generalStatistics__item}>
				<TotalHoursIcon className={styles.generalStatistics__item_icon} />
				<div className={styles.generalStatistics__item_content}>
					<span className={styles.generalStatistics__item_content_counter}>
						{formatNumber(statistics.totalSpendTime)}
					</span>
					<span className={styles.generalStatistics__item_content_title}>{totalHoursTitle}</span>
				</div>
				<Link to={urls.supperAdminVolList} className={styles.generalStatistics__item_link}>
					<CircleArrowButton title={totalHoursTitle} />
				</Link>
			</div>
			<div className={styles.generalStatistics__item}>
				<TotalStudentsIcon className={styles.generalStatistics__item_icon} />
				<div className={styles.generalStatistics__item_content}>
					<span className={styles.generalStatistics__item_content_counter}>
						{formatInteger(statistics.volunteersTotal)}
					</span>
					<span className={styles.generalStatistics__item_content_title}>{totalVolunteersTitle}</span>
				</div>
				<Link to={urls.supperAdminVolList} className={styles.generalStatistics__item_link}>
					<CircleArrowButton title={totalVolunteersTitle} />
				</Link>
			</div>
		</section>
	);
};

export default GeneralStatistics;
